const QuestionOption = ({
  id,
  checked,
  onChange,
  label,
}: {
  id: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
}) => {
  return (
    <div className="questions">
      <input type="checkbox" id={id} checked={checked} onChange={onChange} />
      <label className="question-label" htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

export default QuestionOption;
